// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getToken } from "./localStorageService";
import { BASE_URL_STAGINGHTTP, INITIAL_TOKEN } from "../../config/config";

// using CSRF token from Redux Store

// Define a service using a base URL and expected endpoints
export const SubscriptionApi = createApi({
  reducerPath: "SubscriptionApi",
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL_STAGINGHTTP,

    prepareHeaders: (headers, { getState }) => {
      headers.set("Authorization", `Bearer ${getToken()}`);
      headers.set("Accept", "application/json");
      headers.set("token", INITIAL_TOKEN);
      return headers;
    },
  }),
  // mode: "no-cors",
  credentials: "include",
  endpoints: (builder) => ({
    getSubscriptionDetails: builder.query({
      query: () => {
        return {
          url: "admin/subscriptions",
          method: "GET",
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
    }),
    updateSubscription: builder.mutation({
      query: (modifiedData) => {
        return {
          url: `admin/subscriptions/status/${modifiedData}`,
          method: "PUT",
          // body: modifiedData,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      // invalidatesTags: ['User'],
    }),
    updateSubscriptionsDetail: builder.mutation({
      query: (modifiedData) => {
        return {
          url: `admin/subscriptions/${modifiedData?.id}`,
          method: "PUT",
          body: modifiedData,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      // invalidatesTags: ['User'],
    }),
    deleteSubscription: builder.mutation({
      query: (slug) => {
        return {
          url: `/admin/subscriptions/${slug}`,
          method: "DELETE",
          // body: user,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
    }),
    addSubscriptionsDetail: builder.mutation({
      query: (modifiedData) => {
        return {
          url: `admin/subscriptions`,
          method: "POST",
          body: modifiedData,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      // invalidatesTags: ['User'],
    }),
    getUserSubscription: builder.query({
      query: () => {
        return {
          url: "admin/user-subscriptions",
          method: "GET",
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetSubscriptionDetailsQuery ,
  useUpdateSubscriptionMutation,
  useUpdateSubscriptionsDetailMutation,
  useDeleteSubscriptionMutation,
  useAddSubscriptionsDetailMutation,
  useGetUserSubscriptionQuery,
} = SubscriptionApi;
